import { autoinject } from "aurelia-framework";
import { ContextMenu, ContextMenuDivider } from "./widgets/action-bar/context-menu";
import { Carrier } from "../models/carrier";
import { WebApiService } from "../services/web-api-service";
import { Router } from "aurelia-router";
import { BusyService } from "../services/busy-service";
import * as moment from 'moment';
import { SecurityService } from "../services/security-service";
import { DialogService } from "aurelia-dialog";
import { CarrierStatusDialog } from "./dialogs/carrier-status-dialog";

@autoinject()
export class CarrierStatus {
    carrierId: any;

    constructor(private api: WebApiService, private router: Router,
        private busyService: BusyService,
        private dialogService: DialogService,
        private securityService: SecurityService) {
        this._buildContextMenu();
    }

    activate(parameters) {
        this.parameters = parameters;
        this._loadCarrier(parameters.carrierId);
        this._loadCarrierStatusHistory(parameters.carrierId);
    }

    parameters: any;

    gridData = [];

    columnDefs: Array<any> = [
        { field: "CarrierId", hide: true },
        { field: "Id", hide: true },
        {
            headerName: "Status", field: "Description",
            cellRenderer: (params) => this.carrierStatusItemDetailsLinkRenderer(params)
        },
        {
            headerName: "Date/Time", field: "BeginOn",
            cellRenderer: (params) => {
                return moment(params.value).format("MM/DD/YYYY h:mm a");
            },
            sort: 'desc'
        },
        { headerName: "User", field: "InsertedBy" },
        { headerName: "Comments", field: "Comment" }
    ];



    carrierStatusItemDetailsLinkRenderer(params: any) {
        if (params.value != null) {
            if (this.securityService.hasRole("edit")) {
                var link = $(`<a href='javascript: void(0)'>${params.value}</a>`)[0];
                link.addEventListener("click", () => {
                    this.editStatus(params.api.getValue("Id", params.node));
                });
                return link;
            } else {
                return params.value;
            }
        }
        return params.value;
    }


    gridOptions = {
        enableSorting: false,
        columnDefs: this.columnDefs,
        pagination: false
    };

    newEntry() {
        this.editStatus(0);
    }

    editStatus(id) {
        this.dialogService.open(
            {
                viewModel: CarrierStatusDialog,
                model: { id: id, carrier: this.carrier }
            })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    //reload carrier comments
                    this._loadCarrierStatusHistory(this.carrier.id);
                    this._loadCarrier(this.carrier.id);
                }
            });
    }

    carrier: Carrier;
    private _loadCarrier(id) {
        this.busyService.on();
        return this.api.get("Carriers", "GetCarrierById", { carrierId: id })
            .then((result) => {
                this.carrier = Object.assign(new Carrier(), JSON.parse(result.response));

                //set the page title
                this.router.currentInstruction.config.navModel.setTitle(this.carrier.legalName + " - Status History");
                this.router.updateTitle();
            }).finally(() => {
                this.busyService.off();
            });
    }

    _loadCarrierStatusHistory(id: any): any {
        this.busyService.on();
        return this.api.get("Carriers", "GetCarrierStatusHistory", { carrierId: id })
            .then((result) => {
                this.gridData = JSON.parse(result.response);
            }).finally(() => {
                this.busyService.off();
            });
    }


    private _buildContextMenu() {
        this.actionBarMenu = new ContextMenu();

        this.actionBarMenu.items.push({
            caption: "Refresh", securityRole: 'view',
            onClick: () => {
                this._loadCarrierStatusHistory(this.carrier.id);
            }
        });

        this.actionBarMenu.items.push({
            caption: "Add new status entry", securityRole: 'admin',
            onClick: () => {
                this.newEntry();
            }
        });

        //this.actionBarMenu.items.push(new ContextMenuDivider());
    }
    actionBarMenu: ContextMenu;

}